import {stripLocalizedRouteLanguageFromPathname} from '../shared/i18n/app-language';

export function safeAuthReturnUrl(value: string | null | undefined): string | null {
  const target = value?.trim() ?? '';
  if (!target.startsWith('/') || target.startsWith('//') || /[\\\u0000-\u001f\u007f]/.test(target)) return null;
  try {
    const url = new URL(target, 'https://invemory.local');
    const decodedPath = decodeURIComponent(url.pathname);
    if (url.origin !== 'https://invemory.local' || decodedPath.startsWith('//') || /[\\()\u0000-\u001f\u007f]/.test(decodedPath)) return null;
    const pathname = decodedPath.split('/').map(segment => segment.split(';', 1)[0]).join('/');
    const route = stripLocalizedRouteLanguageFromPathname(pathname).split('/')[1];
    if (['login', 'logout', 'register', 'forgot-password', 'reset-password', 'verify-email'].includes(route)) return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}
